import Cookies from 'js-cookie';

import { UserData } from '../state/initialGlobalState';

type SessionData = Omit<UserData, 'status'>;

type CookieData = {
    username?: string;
    admin?: boolean;
};

let cookie: SessionData;

try {
    const cookieValues = JSON.parse(Cookies.get('lediumCtx') ?? '') as CookieData;
    cookie = {
        username: cookieValues.username,
        admin: !!cookieValues.admin,
        auth: !!cookieValues.username
    };
} catch (e) {
    cookie = { auth: false };
}

export default cookie;
